// API Client für Ladeorte (Loading Locations)
import { buildApiUrl } from "../lib/api";
import { getAuthHeaders } from "./auth";

export interface LoadingLocation {
    LADEORTNR: string;
    BEZEICHNUNG: string | null;
    PLZ: string | null;
    displayText: string;
}

/**
 * Lädt primäre Ladeorte für einen Lieferanten (LIFNR) aus ZHB_T24
 * Diese Ladeorte sind dem Lieferanten zugeordnet
 */
export async function fetchPrimaryLoadingLocations(lifnr: string): Promise<LoadingLocation[]> {
    try {
        const url = buildApiUrl("/api/loading-locations/primary", { lifnr });
        const response = await fetch(url, {
            headers: getAuthHeaders(),
            credentials: "include"
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch primary loading locations: ${response.status}`);
        }

        const data = await response.json();
        return Array.isArray(data) ? data : [];
    } catch (error) {
        console.error("Error fetching primary loading locations:", error);
        return [];
    }
}

/**
 * Sucht in ZHB_T02 nach Ladeorten (ValueHelp für freie Suche)
 * Wird verwendet, wenn User einen Ladeort eingibt, der nicht in den primären Ladeorten ist
 */
export async function searchSecondaryLoadingLocations(
    search: string,
    limit = 20
): Promise<LoadingLocation[]> {
    if (search.length < 2) {
        return [];
    }

    try {
        const url = buildApiUrl("/api/loading-locations/secondary", { search, limit: String(limit) });
        const response = await fetch(url, {
            headers: getAuthHeaders(),
            credentials: "include"
        });

        if (!response.ok) {
            throw new Error(`Failed to search loading locations: ${response.status}`);
        }

        const data = await response.json();
        return Array.isArray(data) ? data : [];
    } catch (error) {
        console.error("Error searching loading locations:", error);
        return [];
    }
}
